import Hero from '../../components/Hero'
import './Hospitality.css'

const Hospitality = () => {
  return (
    <>
      <Hero 
        title="Hospitality & Leisure"
        subtitle="Immaculate cleaning solutions for hotels, restaurants and event venues."
        backgroundImage="/sectors/hospitality/hospitality.png"
        height="55.78125vh"
      />
      
      <section>
        <div className="section-header">
          <h2>Sector Overview</h2>
        </div>
        <p>In the hospitality industry, first impressions are everything. A sparkling environment ensures guests feel welcome, comfortable and safe. Our teams are trained to deliver meticulous cleaning services that uphold your brand standards and regulatory requirements. We work around your operational hours to minimise disruption and ensure seamless experiences for guests and staff alike.</p>
        <div className="hospitality-grid">
          <article>
            <h3>Hotels &amp; Resorts</h3>
            <p>Room servicing, lobby and public area cleaning, housekeeping support and speciality floor care tailored to your property.</p>
          </article>
          <article>
            <h3>Restaurants &amp; Cafés</h3>
            <p>Front‑of‑house and kitchen cleaning, sanitisation of food preparation areas, and compliance with health regulations.</p>
          </article>
          <article>
            <h3>Event Venues &amp; Cinemas</h3>
            <p>Pre‑ and post‑event cleaning services for theatres, conference centres and entertainment venues to ensure spotless spaces.</p>
          </article>
          <article>
            <h3>Clubs &amp; Casinos</h3>
            <p>Daily cleaning and specialised tasks for gaming floors, bars, restaurants and back‑of‑house facilities.</p>
          </article>
        </div>
      </section>
      
      <section className="cta-section">
        <h2>Deliver Exceptional Experiences</h2>
        <p>Let us handle the cleaning, so you can focus on delighting your guests. Talk to us about a tailored hospitality cleaning program.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default Hospitality
